import React from 'react'; 
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './layout/Layout';

import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import PurohitManagement from './pages/PurohitManagement';
import PurohitMapPage from './pages/PurohitMapPage';
import CategoryManagement from './pages/CategoryManagement';
import AartiManagement from './pages/AartiManagement';
import MantraList from './pages/MantraList';
import ArticleManagement from './pages/ArticleManagement';
import YoutubeManagement from './pages/YoutubeManagement';
import VideoManagement from './pages/VideoManagement';
import BannerManagement from './pages/BannerManagement';
import EventManagement from './pages/EventManagement';
import ProductManagement from './pages/ProductManagement';
import TempleManagement from './pages/TempleManagement';
import BookingManagement from './pages/BookingManagement';
import PaymentManagement from './pages/PaymentManagement';
import NotificationManagement from './pages/NotificationManagement';

import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import ContentLibraryManagement from './pages/ContentLibraryManagement';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Protected section starts here */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="UserManagement" element={<UserManagement />} />
          <Route path="PurohitManagement" element={<PurohitManagement />} />
          <Route path="PurohitMaps" element={<PurohitMapPage />} />   
          <Route path="CategoryManagement" element={<CategoryManagement />} />
          <Route path="AartiManagement" element={<AartiManagement />} />
          <Route path="MantraList" element={<MantraList />} />
          <Route path="ArticleManagement" element={<ArticleManagement />} />
          <Route path="YoutubeManagement" element={<YoutubeManagement />} />
          <Route path="VideoManagement" element={<VideoManagement />} />
          <Route path="BannerManagement" element={<BannerManagement />} />
          <Route path="ContentLibraryManagement" element={<ContentLibraryManagement />} />
          <Route path="EventManagement" element={<EventManagement />} />
          <Route path="ProductManagement" element={<ProductManagement />} />
          <Route path="TempleManagement" element={<TempleManagement />} />
          <Route path="BookingManagement" element={<BookingManagement />} />
          <Route path="PaymentManagement" element={<PaymentManagement />} />
          <Route path="NotificationManagement" element={<NotificationManagement />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
